import { ApplicationView, useController } from '@aha-app/mvc';
import React from 'react';
import { PreviewWhiteboard } from './Whiteboard';
import styles from './components/history/history.module.css';
import WhiteboardController from './controllers/WhiteboardController';
import { formatDate, formatTime } from './utils/time';

const VersionPreview: React.FC = () => {
  const controller = useController(WhiteboardController);
  const historyManager = controller.historyManager;

  if (!historyManager) {
    return null;
  }

  const { previewData } = historyManager.state;

  if (previewData) {
    return (
      <div className={styles.previewArea}>
        <div className={styles.previewBadge}>
          <span className='font-600'>Viewing</span>
          <span>{formatDate(previewData.updatedAt)}</span>
          <span style={{ color: 'var(--theme-accent-text)' }}>
            {formatTime(previewData.updatedAt)}
          </span>
        </div>
        <PreviewWhiteboard
          key={historyManager.state.previewVersionId}
          initialData={previewData}
          readOnly={true}
          canPresent={false}
          isHistoryPreview
        ></PreviewWhiteboard>
      </div>
    );
  } else {
    return null;
  }
};

export default ApplicationView(VersionPreview);
